/**
 * TimeToFinishExtraFieldType - Type d'extraField pour le temps restant ESCAPE
 * Identique à TimeToFinishExtraField.java
 */

import {ExtraFieldType} from '../../types/ExtraFieldType';
import {GameDataExtraField} from '../../../models/GameDataExtraField';
import {GameState} from '../../../models/GameState';

export class TimeToFinishExtraFieldType implements ExtraFieldType {
  typeName = 'ESCAPE_TIME_TO_FINISH';
  defaultValue = '3600';

  process(field: GameDataExtraField, gameState: GameState): void {
    // Pas de traitement spécial nécessaire
  }

  /**
   * Génère une valeur à partir d'une expression
   * Pour ESCAPE, c'est juste un nombre (pas de dés)
   * 
   * @param fieldValue Valeur numérique (ex: "3600")
   * @returns Valeur générée (ex: "3600")
   */
  generateValue(fieldValue: string): string {
    // Pour ESCAPE, c'est juste un nombre, pas besoin de lancer de dés
    // Si la valeur est vide, utiliser la defaultValue
    if (!fieldValue || fieldValue.trim() === '') {
      return this.defaultValue;
    }
    // Vérifier que c'est un nombre valide
    const numValue = parseInt(fieldValue, 10);
    if (isNaN(numValue)) {
      return this.defaultValue;
    }
    return numValue.toString();
  }
}
